module.exports = __webpack_public_path__ + "static/img/rz(3).f2728805.jpg";